import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Search, Filter, PlayCircle, Clock, ShieldCheck, FolderKanban, Users, BarChart3, FileText, Lock } from 'lucide-react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { AgencyModal } from './AgencyModal';
import { motion } from 'framer-motion';
export const Audiences = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-24 bg-white" data-id="element-129">
      <AgencyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-130" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        {/* Why Work with Talent Agencies */}
        <div className="mb-32" data-id="element-132">
          <div className="flex flex-col lg:flex-row-reverse gap-16 items-center" data-id="element-133">
            <div className="w-full lg:w-1/2" data-id="element-134">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-135">
                Why work with talent agencies?
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-136">
                Get fast responses and more reliable relationships you can count
                on. Talent managers on Zano actively manage their rosters and
                respond directly to brand inquiries — faster, professional
                responses from the people who know their influencers best.
              </p>
              <p className="text-base text-gray-600 mb-6" data-id="element-137">
                Not only do they give you access to the industry's top creators,
                they're business people who understand your goals and needs.
                Their job is to sell their influencers. The influencers' job is
                to work on their content. You get the best of the best and talk
                directly to who handles it.
              </p>
              <p className="text-base text-gray-700 font-medium mb-6" data-id="element-138">
                The Talent Agency Directory lists all 400+ talent agencies on
                Zano with their main point of contact, website, and total roster
                following.
              </p>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-6 flex items-start gap-3" data-id="element-139">
                <div className="p-1.5 bg-white rounded-md shadow-sm shrink-0" data-id="element-140">
                  <Lock size={14} className="text-gray-500" data-id="element-141" />
                </div>
                <p className="text-xs text-gray-600 leading-relaxed" data-id="element-142">
                  <span className="font-semibold text-gray-900" data-id="element-143">
                    Approved access required.
                  </span>{' '}
                  Anyone can post a casting call to our network of agencies, but
                  viewing the premium roster database and talent agency
                  directory requires an approved brand account.
                </p>
              </div>
              <Link to="/pricing" data-id="element-144">
                <Button variant="primary" data-id="element-145">Start Free Trial</Button>
              </Link>
            </div>

            <div className="w-full lg:w-1/2" data-id="element-146">
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-147">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-148">
                  <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-149">
                    <div className="flex items-center gap-2" data-id="element-150">
                      <Users size={16} className="text-gray-500" data-id="element-151" />
                      <span className="font-semibold text-sm text-gray-800" data-id="element-152">
                        Talent Agency Directory
                      </span>
                    </div>
                    <Badge className="bg-purple-100 text-purple-800 border border-purple-200" data-id="element-153">
                      400+ Agencies
                    </Badge>
                  </div>

                  <div className="p-0 overflow-x-auto" data-id="element-154">
                    <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-155">
                      <thead className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 uppercase" data-id="element-156">
                        <tr data-id="element-157">
                          <th className="px-4 py-3 font-medium" data-id="element-158">Agency</th>
                          <th className="px-4 py-3 font-medium" data-id="element-159">Main POC</th>
                          <th className="px-4 py-3 font-medium" data-id="element-160">Website</th>
                          <th className="px-4 py-3 font-medium" data-id="element-161">
                            Total Following
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-162">
                        <tr data-id="element-163">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-164">
                            Clicks Talent
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-165">
                            John Marcus
                          </td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-166">
                            clickstalent.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-167">
                            14.2M
                          </td>
                        </tr>
                        <tr data-id="element-168">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-169">
                            Viral Nation
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-170">Ena</td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-171">
                            viralnation.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-172">
                            28.5M
                          </td>
                        </tr>
                        <tr data-id="element-173">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-174">
                            Boost Society
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-175">Josh</td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-176">
                            boost-society.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-177">
                            8.1M
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* For Talent Agencies */}
        <div className="bg-gray-900 text-white rounded-3xl p-8 lg:p-12 -mx-4 sm:mx-0" data-id="element-178">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-179">
            <div className="w-full lg:w-1/2" data-id="element-180">
              <Badge className="mb-4 bg-gray-800 text-gray-300 border border-gray-700" data-id="element-181">
                For Talent Agencies
              </Badge>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-182">
                Turn every creator into a live, bookable asset
              </h2>
              <p className="text-lg text-gray-400 mb-6" data-id="element-183">
                Showcase your roster, maintain living media kits, and receive
                qualified campaign opportunities from brands.
              </p>
              <div className="grid grid-cols-1 gap-4 mb-8" data-id="element-184">
                {['Roster management — manage your roster internally with live performance data in one clean, easy-to-scan table', 'Get your influencers deals from brands/marketing agencies on Zano', 'Get live public media kits you can share externally', 'Submit influencers to exclusive casting calls'].map((item, idx) => <div key={idx} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-185">
                    <CheckCircle2 size={18} className="text-zano-pink shrink-0 mt-0.5" data-id="element-186" />
                    <span data-id="element-187">{item}</span>
                  </div>)}
              </div>
              <div className="flex flex-col sm:flex-row items-center gap-4 mb-4" data-id="element-188">
                <Link to="/for-talent" className="w-full sm:w-auto" data-id="element-189">
                  <Button variant="secondary" className="w-full sm:w-auto border-gray-700 text-white hover:bg-gray-800" data-id="element-190">
                    Learn More
                  </Button>
                </Link>
                <Button variant="primary" className="w-full sm:w-auto" onClick={() => setIsModalOpen(true)} data-id="element-191">
                  List Your Agency
                </Button>
              </div>
              <p className="text-sm text-gray-400" data-id="element-192">
                Want to see how it works?{' '}
                <a href="https://www.youtube.com/watch?v=d0T7ZbxsxrY" target="_blank" rel="noopener noreferrer" className="text-zano-pink hover:text-zano-pinkDark font-medium underline underline-offset-2 inline-flex items-center gap-1" data-id="element-193">
                  <PlayCircle size={15} data-id="element-194" /> Watch a demo video
                </a>
              </p>
            </div>

            <div className="w-full lg:w-1/2 relative" data-id="element-195">
              {/* Product UI Mockup: Talent Agency Roster Dashboard with Profile Header Layer */}
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-196">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-197">
                  <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-198">
                    <div className="flex items-center gap-2" data-id="element-199">
                      <Users size={16} className="text-gray-500" data-id="element-200" />
                      <span className="font-semibold text-sm text-gray-800" data-id="element-201">
                        My Roster
                      </span>
                    </div>
                    <Button variant="primary" className="text-xs px-3 py-1.5 h-auto" data-id="element-202">
                      + Add creator
                    </Button>
                  </div>

                  <div className="p-0 overflow-x-auto" data-id="element-203">
                    <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-204">
                      <thead className="bg-gray-50 border-b border-gray-100 text-gray-500 uppercase" data-id="element-205">
                        <tr data-id="element-206">
                          <th className="px-4 py-3 font-medium" data-id="element-207">Name</th>
                          <th className="px-4 py-3 font-medium" data-id="element-208">Category</th>
                          <th className="px-4 py-3 font-medium" data-id="element-209">
                            <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1248.png" alt="TikTok" className="w-3 h-3 inline-block" data-id="element-210" />
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-211">
                            <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1249.png" alt="Instagram" className="w-3 h-3 inline-block" data-id="element-212" />
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-213">
                            <svg className="w-3.5 h-3.5 inline-block text-[#FF0000]" viewBox="0 0 24 24" fill="currentColor" aria-label="YouTube" data-id="element-214">
                              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-215" />
                            </svg>
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-216">Status</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-217">
                        <tr className="hover:bg-gray-50" data-id="element-218">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-219">
                            <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-220" />
                            <span className="font-medium text-gray-900" data-id="element-221">
                              Elena Rodriguez
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-222">Fashion</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-223">1.2M</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-224">340K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-225">-</td>
                          <td className="px-4 py-3" data-id="element-226">
                            <Badge className="bg-green-50 text-green-700 border border-green-200 text-[10px] px-2 py-0.5" data-id="element-227">
                              Live
                            </Badge>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50" data-id="element-228">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-229">
                            <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-230" />
                            <span className="font-medium text-gray-900" data-id="element-231">
                              Marcus Chen
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-232">Tech</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-233">850K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-234">120K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-235">2.1M</td>
                          <td className="px-4 py-3" data-id="element-236">
                            <Badge className="bg-orange-50 text-orange-700 border border-orange-200 text-[10px] px-2 py-0.5" data-id="element-237">
                              Action Required
                            </Badge>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50" data-id="element-238">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-239">
                            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-240" />
                            <span className="font-medium text-gray-900" data-id="element-241">
                              Sarah Jenkins
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-242">Lifestyle</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-243">450K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-244">890K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-245">-</td>
                          <td className="px-4 py-3" data-id="element-246">
                            <Badge className="bg-green-50 text-green-700 border border-green-200 text-[10px] px-2 py-0.5" data-id="element-247">
                              Live
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Floating Profile Header Layer */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="absolute -bottom-6 -right-4 sm:-right-8 w-80 bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-4 z-20" data-id="element-248">
                <div className="flex items-center gap-3" data-id="element-249">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=64&h=64" alt="Elena Rodriguez" className="w-12 h-12 rounded-full object-cover shrink-0" data-id="element-250" />
                  <div className="min-w-0" data-id="element-251">
                    <h4 className="text-sm font-bold text-gray-900 leading-tight" data-id="element-252">
                      Elena Rodriguez
                    </h4>
                    <p className="text-xs font-medium text-gray-700" data-id="element-253">
                      ABC Talent Agency
                    </p>
                    <span className="inline-flex items-center gap-1 mt-0.5 text-[10px] font-semibold text-emerald-600" data-id="element-254">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-255" />
                      Exclusive
                    </span>
                    <p className="text-[11px] text-gray-500 mt-0.5 truncate" data-id="element-256">
                      john.smith@abctalent.com
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};